import { GAME_OUTCOMES, GAME_RINGS } from '../../utils/game';
import { BANKER, PLAYER, TIE } from '../../utils/utils';

import SingleChip from './SingleChip';

import IconCardStack from '../../components/Icons/IconCardStack';

type Props = {
  renderAmount: number;
  renderPlayer: React.ReactNode;
  renderBanker: React.ReactNode;
  renderWinner: React.ReactNode;
  renderOutcome: any;
  handleTie: any;
  handleBanker: any;
  handlePlayer: any;
};

const LayoutGame = ({
  renderAmount,
  renderPlayer,
  renderBanker,
  renderWinner,
  renderOutcome,
  handleTie,
  handleBanker,
  handlePlayer,
}: Props) => {
  const renderGameRings = () => {
    return GAME_RINGS.map((ring, idx) => (
      <div key={idx} className={`game__${ring}`}>
        {idx === 3 ? <IconCardStack /> : null}
      </div>
    ));
  };

  const renderChip = (outcome: string) => {
    switch (outcome) {
      case TIE:
        return <SingleChip outcome={TIE} amount={renderAmount} />;

      case BANKER:
        return <SingleChip outcome={BANKER} amount={renderAmount} />;

      case PLAYER:
        return <SingleChip outcome={PLAYER} amount={renderAmount} />;

      default:
        return;
    }
  };

  const renderGameOutcomes = () => {
    return GAME_OUTCOMES.map((outcome, idx) => <p key={idx}>{outcome}</p>);
  };

  return (
    <div className="game">
      <div className="game__rings">{renderGameRings()}</div>
      {renderPlayer}
      {renderBanker}
      <div className="game__players">
        {renderChip(renderOutcome)}
        {renderGameOutcomes()}
        {renderWinner}
      </div>
      <div className={`game__option game__option--${TIE}`} onClick={handleTie} />
      <div className={`game__option game__option--${BANKER}`} onClick={handleBanker} />
      <div className={`game__option game__option--${PLAYER}`} onClick={handlePlayer} />
    </div>
  );
};

export default LayoutGame;
